import { render, staticRenderFns } from "./MassagePrepare.vue?vue&type=template&id=fdd8e6a2&scoped=true"
import script from "./MassagePrepare.vue?vue&type=script&lang=js"
export * from "./MassagePrepare.vue?vue&type=script&lang=js"
import style0 from "./MassagePrepare.vue?vue&type=style&index=0&id=fdd8e6a2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd8e6a2",
  null
  
)

export default component.exports